// This is an auto-generated file. Do not edit directly. Edit 'packages/design-v2/globals/colors/app-vars.module.css' and then run 'packages/design-v2/node-scripts/css-variable-convert.js'
export enum APP_COLORS {
  clrNbiBlack = '--clrNbiBlack',
  clrGreyDark = '--clrGreyDark',
  clrGreyHeavy = '--clrGreyHeavy',
  clrGreyMedium = '--clrGreyMedium',
  clrGreyLight = '--clrGreyLight',
  clrGreySuperLight = '--clrGreySuperLight',
  clrNbiMagenta = '--clrNbiMagenta',
  clrNbiMagentaDark = '--clrNbiMagentaDark',
  clrNbiMagentaLight = '--clrNbiMagentaLight',
  clrNbiMagentaTint = '--clrNbiMagentaTint',
  clrGood = '--clrGood',
  clrGoodDark = '--clrGoodDark',
  clrGoodLight = '--clrGoodLight',
  clrBad = '--clrBad',
  clrBadDark = '--clrBadDark',
  clrBadDarker = '--clrBadDarker',
  clrBadLight = '--clrBadLight',
  clrWarning = '--clrWarning',
  clrWarningDark = '--clrWarningDark',
  clrWarningLight = '--clrWarningLight',
  clrStandby = '--clrStandby',
  clrInfo = '--clrInfo',
  clrInfoLight = '--clrInfoLight',
  clrInfoDark = '--clrInfoDark',
  clrFT = '--clrFT',
  clrSblPending = '--clrSblPending',
  clrStatusConfirmed = '--clrStatusConfirmed',
  clrStatusUnconfirmed = '--clrStatusUnconfirmed',
  clrStatusSeated = '--clrStatusSeated',
  clrStatusPartiallySeated = '--clrStatusPartiallySeated',
  clrStatusCancelled = '--clrStatusCancelled',
  clrStatusReserved = '--clrStatusReserved',
  clrStatusOrdered = '--clrStatusOrdered',
  clrStatusResetTable = '--clrStatusResetTable',
  clrStatusTableSet = '--clrStatusTableSet',
  clrStatusBlocked = '--clrStatusBlocked',
  clrStatusFinished = '--clrStatusFinished',
  clrStatusSeatedOrdered = '--clrStatusSeatedOrdered'
}


// This is an auto-generated file. Do not edit directly. Edit 'packages/design-v2/globals/colors/app-vars.module.css' and then run 'packages/design-v2/node-scripts/css-variable-convert.js'
export const Colors = new Map<APP_COLORS, string>([
  [APP_COLORS.clrNbiBlack, "#212121"],
  [APP_COLORS.clrGreyDark, "#333333"],
  [APP_COLORS.clrGreyHeavy, "#808080"],
  [APP_COLORS.clrGreyMedium, "#C2C2C2"],
  [APP_COLORS.clrGreyLight, "#DFDFDF"],
  [APP_COLORS.clrGreySuperLight, "#F8F8F8"],
  [APP_COLORS.clrNbiMagenta, "#992662"],
  [APP_COLORS.clrNbiMagentaDark, "#992662"],
  [APP_COLORS.clrNbiMagentaLight, "#A51B63"],
  [APP_COLORS.clrNbiMagentaTint, "#FFF5FB"],
  [APP_COLORS.clrGood, "#54C66D"],
  [APP_COLORS.clrGoodDark, "#409b54"],
  [APP_COLORS.clrGoodLight, "#79e991"],
  [APP_COLORS.clrBad, "#FF0000"],
  [APP_COLORS.clrBadDark, "#cb0000"],
  [APP_COLORS.clrBadDarker, "#921e1e"],
  [APP_COLORS.clrBadLight, "#ff6a6a"],
  [APP_COLORS.clrWarning, "#F18C16"],
  [APP_COLORS.clrWarningDark, "#d37407"],
  [APP_COLORS.clrWarningLight, "#ffb45d"],
  [APP_COLORS.clrStandby, "#4669ac"],
  [APP_COLORS.clrInfo, "#29b6f6"],
  [APP_COLORS.clrInfoLight, "#5bc8f8"],
  [APP_COLORS.clrInfoDark, "#1d91c5"],
  [APP_COLORS.clrFT, "#03d0f4a8"],
  [APP_COLORS.clrSblPending, "#4669ac"],
  [APP_COLORS.clrStatusConfirmed, "#ceffe1"],
  [APP_COLORS.clrStatusUnconfirmed, "#ffe6a6"],
  [APP_COLORS.clrStatusSeated, "#0ae228"],
  [APP_COLORS.clrStatusPartiallySeated, "#f68b1f"],
  [APP_COLORS.clrStatusCancelled, "#ff0030"],
  [APP_COLORS.clrStatusReserved, "#F4A155"],
  [APP_COLORS.clrStatusOrdered, "#7998E8"],
  [APP_COLORS.clrStatusResetTable, "#A89DF1"],
  [APP_COLORS.clrStatusTableSet, "#C189BF"],
  [APP_COLORS.clrStatusBlocked, "#AFAFAF"],
  [APP_COLORS.clrStatusFinished, "#ccc"],
  [APP_COLORS.clrStatusSeatedOrdered, "#267347"]
]);